/**
 * Canonical module names. They mirror the 8 categories of "Consultas resueltas"
 * 1:1 and are kept in sync with module_content.premium_service_name.
 * The internal keys (sabor, semilla…) are technical ids only; never shown.
 */
export const MODULE_LABELS: Record<string, string> = {
  sabor: "Clientes y ventas",
  semilla: "Finanzas",
  equipo: "Equipo",
  jugo: "Gestión y operativa",
  escaparate: "Marketing y visibilidad",
  ia_automatizacion: "Digitalización y tecnología",
  blindaje_legal: "Legal, fiscal y administrativo",
  crecimiento: "Crecimiento y expansión",
};

export const MODULE_LABELS_EN: Record<string, string> = {
  sabor: "Customers & Sales",
  semilla: "Finance",
  equipo: "Team",
  jugo: "Operations & Stock",
  escaparate: "Marketing & Visibility",
  ia_automatizacion: "Digital & Tech",
  blindaje_legal: "Legal, Tax & Admin",
  crecimiento: "Growth & Expansion",
};

export const MODULE_SUBTITLES: Record<string, string> = {
  sabor: "Atracción, ticket medio y fidelización",
  semilla: "Márgenes, costes, caja y rentabilidad",
  equipo: "Selección, motivación, turnos y ambiente",
  jugo: "Inventario, proveedores, tiempos y procesos",
  escaparate: "Presencia local, Google Maps, redes y escaparate",
  ia_automatizacion: "IA aplicada y tareas automatizadas",
  blindaje_legal: "Contratos, alquiler, licencias y normativa",
  crecimiento: "Segundo local, colaboraciones, reformas y nuevos canales",
};

export const MODULE_SUBTITLES_EN: Record<string, string> = {
  sabor: "Acquisition, basket size and loyalty",
  semilla: "Margins, costs, cash and profitability",
  equipo: "Hiring, motivation, shifts and team climate",
  jugo: "Inventory, suppliers, time and processes",
  escaparate: "Local presence, Google Maps, social and window display",
  ia_automatizacion: "Applied AI and automated tasks",
  blindaje_legal: "Contracts, lease, licences and regulations",
  crecimiento: "Second store, partnerships, refits and new channels",
};

/** Display order of the roadmap modules (same order as Consultas resueltas). */
export const MODULE_ORDER = [
  "sabor",
  "semilla",
  "equipo",
  "jugo",
  "escaparate",
  "ia_automatizacion",
  "blindaje_legal",
  "crecimiento",
] as const;

export const getModuleLabel = (key: string, lang: "es" | "en" = "es"): string =>
  (lang === "en" ? MODULE_LABELS_EN[key] : MODULE_LABELS[key]) ?? MODULE_LABELS[key] ?? key;

export const getModuleSubtitle = (key: string, lang: "es" | "en" = "es"): string =>
  (lang === "en" ? MODULE_SUBTITLES_EN[key] : MODULE_SUBTITLES[key]) ?? "";

export const MODULE_EMOJIS: Record<string, string> = {
  sabor: "🛍️",
  semilla: "💶",
  equipo: "👥",
  jugo: "📦",
  escaparate: "📣",
  ia_automatizacion: "🤖",
  blindaje_legal: "🛡️",
  crecimiento: "🚀",
};

export const MODULE_SHORT_LABELS: Record<string, string> = {
  sabor: "Clientes",
  semilla: "Finanzas",
  equipo: "Equipo",
  jugo: "Gestión",
  escaparate: "Marketing",
  ia_automatizacion: "Digital",
  blindaje_legal: "Legal",
  crecimiento: "Crecimiento",
};
